var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "principalOverviewWorkRef",
      staticStyle: { padding: "0 10px 30px" },
    },
    [
      _c(
        "a-row",
        { staticClass: "child-full-width overview-bgColor" },
        [
          _c(
            "a-col",
            {
              staticClass: "title-1",
              staticStyle: { margin: "15px 0" },
              attrs: { span: 24 },
            },
            [_vm._v("校园情绪概览")]
          ),
          _c(
            "a-col",
            {
              staticStyle: {
                padding: "20px",
                "background-color": "#fff",
                "border-radius": "10px",
              },
              attrs: { span: 24 },
            },
            [
              _c(
                "a-row",
                {
                  staticClass: "row-box",
                  staticStyle: { "padding-top": "10px" },
                  attrs: { gutter: [15, 15] },
                },
                [
                  _c(
                    "a-col",
                    { attrs: { lg: 7, md: 9, sm: 24, xl: 4 } },
                    [
                      _c("j-dict-select-tag", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请选择年级",
                          dictCode:
                            "school_grade,grade_name,id,0=delete_flag order by sort_order",
                          isShowEmpty: false,
                        },
                        on: {
                          select: (record) => {
                            _vm.$set(_vm.queryParam, "classId", undefined)
                            _vm.$set(_vm.selectLevelObj, "grade", record)
                          },
                          clear: function ($event) {
                            return _vm.$set(
                              _vm.queryParam,
                              "classId",
                              undefined
                            )
                          },
                        },
                        model: {
                          value: _vm.queryParam.gradeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "gradeId", $$v)
                          },
                          expression: "queryParam.gradeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 7, md: 9, sm: 24, xl: 4 } },
                    [
                      _c("j-dict-select-tag", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请选择班级",
                          dictCode:
                            "school_class,name,id,grade_id=" +
                            (!_vm.queryParam.gradeId
                              ? -1
                              : _vm.queryParam.gradeId),
                          disabled: !_vm.queryParam.gradeId,
                          isShowEmpty: false,
                        },
                        on: {
                          select: (record) => {
                            _vm.$set(_vm.selectLevelObj, "class", record)
                          },
                        },
                        model: {
                          value: _vm.queryParam.classId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "classId", $$v)
                          },
                          expression: "queryParam.classId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { lg: 6, md: 9, sm: 24, xl: 4 } },
                    [
                      _c("a-range-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          value: _vm.rangeDate,
                          getCalendarContainer: (node) => node.parentNode,
                        },
                        on: { change: _vm.onRangeChange },
                      }),
                    ],
                    1
                  ),
                  _vm._l(_vm.searchItem, function (item, index) {
                    return _c(
                      "a-col",
                      {
                        key: index,
                        staticClass: "tag-col",
                        attrs: { span: 2 },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tag-item",
                            style: {
                              borderLeft: `4px solid ${_vm.searchItemColor[index]}`,
                            },
                          },
                          [
                            _c("span", { staticClass: "tag-name" }, [
                              _vm._v(_vm._s(item)),
                            ]),
                            _c("a-icon", {
                              staticClass: "delete-icon",
                              attrs: { type: "close-circle" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteBtn(item, index)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  _vm.contrastInputStatus
                    ? _c(
                        "a-col",
                        { staticClass: "select-box", attrs: { span: 4 } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                "not-found-content": null,
                                "show-search": "",
                              },
                              on: {
                                search: _vm.handleSearch,
                                inputKeydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return (() => {
                                    _vm.contrastInputStatus = false
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  attrs: { slot: "dropdownRender" },
                                  slot: "dropdownRender",
                                },
                                [
                                  _c("recycle-scroller", {
                                    staticClass: "virtual-list",
                                    staticStyle: { "max-height": "200px" },
                                    attrs: {
                                      buffer: 1000,
                                      "item-size": 40,
                                      items: _vm.keyword,
                                      prerender: 200,
                                      "key-field": "period_id",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ item, index }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "list-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleSelect(
                                                        item.period_id,
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.name) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      943984433
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("a-icon", {
                            staticClass: "select-del-icon",
                            attrs: { type: "close-circle" },
                            on: {
                              click: () => {
                                _vm.contrastInputStatus = false
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("a-col", { attrs: { span: 3 } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-right": "10px" },
                            on: { click: _vm.addContrast },
                          },
                          [_vm._v("+ 添加对比")]
                        ),
                        _c(
                          "a-button",
                          {
                            attrs: { icon: "search", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.chaDate(true)
                              },
                            },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
              _c(
                "a-col",
                {
                  staticStyle: { "padding-right": "8px" },
                  attrs: { span: 16 },
                },
                [
                  _c(
                    "a-card",
                    {
                      staticClass: "left-card-box",
                      attrs: { bordered: false, loading: _vm.loading },
                    },
                    [
                      _c(
                        "LineChart",
                        {
                          ref: "schoolMoodRef",
                          attrs: {
                            dataSource: _vm.schoolMood,
                            fields: _vm.moodField,
                            title: `${_vm.lineMoodTitle}情绪变化趋势`,
                            height: "280px",
                            showAvgBtn: "",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "titleExtra" },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "add-btn",
                                  attrs: { type: "primary" },
                                  on: { click: _vm.addEventClick },
                                },
                                [_vm._v("添加事件")]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { staticStyle: { "padding-left": "8px" }, attrs: { span: 8 } },
                [
                  _c(
                    "a-tabs",
                    {
                      staticClass: "emotional-trend-card",
                      on: { change: _vm.changeTab },
                    },
                    _vm._l(_vm.emotionalTrendTabs, function (item) {
                      return _c(
                        "a-tab-pane",
                        { key: item.key, attrs: { tab: item.tab } },
                        [
                          _c(
                            "a-card",
                            {
                              attrs: { bordered: false, loading: _vm.loading },
                            },
                            [
                              _c("TableList", {
                                staticStyle: { height: "294px" },
                                attrs: {
                                  columns: _vm.emotionalTrend.columns,
                                  scroll: { y: 220 },
                                  bordered: "",
                                  tableData: _vm.emotionalTrend.tableData,
                                },
                                on: {
                                  addContrast: (record) =>
                                    _vm.addContrastCell(record),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "total",
                                      fn: function ({ record }) {
                                        return _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "font-size": "16px",
                                                  "font-weight": "bold",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(record.total) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _c("div", [
                                              record.total != record.school
                                                ? _c("img", {
                                                    staticStyle: {
                                                      width: "10px",
                                                      "margin-right": "5px",
                                                    },
                                                    attrs: {
                                                      src: require(`@assets/imgs/school/${
                                                        record.total >
                                                        record.school
                                                          ? "rise"
                                                          : "descend"
                                                      }.png`),
                                                      alt: "",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "13px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "全校平均值" +
                                                      _vm._s(record.school)
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        )
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c("MoodChangeDesc", {
                    ref: "moodChangeDescRef",
                    staticStyle: { width: "100%" },
                    attrs: { dataRange: _vm.rangeDate },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "title-1", staticStyle: { margin: "20px 0 10px" } },
        [_vm._v("设备采集情况")]
      ),
      _c("div", { staticClass: "equipment-list flex-between" }, [
        _c(
          "div",
          {
            staticClass: "equipment-item",
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
            },
          },
          [
            _c("div", [
              _c("div", { staticStyle: { "font-size": "16px" } }, [
                _vm._v("学生总数"),
              ]),
              _c(
                "div",
                { staticClass: "font-text" },
                [
                  _c("CountAnimation", {
                    attrs: { "end-val": _vm.collectedInfo.studentCount },
                  }),
                ],
                1
              ),
            ]),
            _c("div", [
              _c("div", { staticStyle: { "font-size": "16px" } }, [
                _vm._v("人脸采集数"),
              ]),
              _c(
                "div",
                { staticClass: "font-text" },
                [
                  _c("CountAnimation", {
                    attrs: { "end-val": _vm.collectedInfo.studentFaceCount },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "icon-area flex-center",
                staticStyle: { background: "#eef4ff" },
              },
              [
                _c("img", {
                  staticStyle: { width: "24px", height: "24px" },
                  attrs: {
                    src: require(`@/assets/imgs/school/guardStuTotal.png`),
                    alt: "",
                  },
                }),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "equipment-other-item" }, [
          _c(
            "div",
            { staticClass: "flex-align-center" },
            [
              _c(
                "div",
                { staticClass: "flex-align-center tag-list" },
                _vm._l(_vm.timeTagList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: {
                        "list-tag-item": true,
                        "active-tag": _vm.equipmentTagIndex == index,
                      },
                      on: {
                        click: function ($event) {
                          _vm.equipmentTagIndex = index
                        },
                      },
                    },
                    [_vm._v("\n            " + _vm._s(item) + "\n          ")]
                  )
                }),
                0
              ),
              _c("a-range-picker", {
                staticStyle: { width: "220px", margin: "0 15px" },
                attrs: {
                  "allow-clear": false,
                  getCalendarContainer: (node) => node.parentNode,
                },
                model: {
                  value: _vm.equipmentDateRange,
                  callback: function ($$v) {
                    _vm.equipmentDateRange = $$v
                  },
                  expression: "equipmentDateRange",
                },
              }),
              _c(
                "a-button",
                {
                  attrs: { icon: "search", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.equipmentQuery(true)
                    },
                  },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "flex-align-center",
              staticStyle: { "margin-top": "5px", "padding-left": "10px" },
            },
            [
              _c("div", { staticStyle: { flex: "1" } }, [
                _c("div", { staticStyle: { "font-size": "16px" } }, [
                  _vm._v("未采集人数"),
                ]),
                _c(
                  "div",
                  {
                    style: {
                      marginTop: "3px",
                      fontSize: "28px",
                      fontWeight: 600,
                      color: "#FA3A25",
                    },
                  },
                  [
                    _c("CountAnimation", {
                      attrs: { "end-val": _vm.baseMapInfo.haveBaseMapCount },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex-align-center" },
                  [
                    _c("div", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v("\n              无底图\n              "),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(_vm.baseMapInfo.noBaseMapCount)),
                      ]),
                      _vm._v("\n              人\n            "),
                    ]),
                    _c("div", [
                      _vm._v("\n              人脸录入未采集\n              "),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(_vm.baseMapInfo.haveBaseMapCount)),
                      ]),
                      _vm._v("\n              人\n            "),
                    ]),
                    _c(
                      "a-button",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { type: "primary", ghost: "" },
                        on: { click: _vm.goNotCollectDetail },
                      },
                      [_vm._v("\n              查看详情\n            ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticStyle: { flex: "1", "padding-left": "10px" } },
                [
                  _c("div", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v("抓拍覆盖率"),
                  ]),
                  _c(
                    "div",
                    {
                      style: {
                        marginTop: "3px",
                        fontSize: "28px",
                        fontWeight: 600,
                      },
                    },
                    [
                      _c("CountAnimation", {
                        attrs: {
                          "end-val": _vm.collectedInfo.coverageRate,
                          attr: { decimals: 2 },
                        },
                      }),
                      _vm._v("\n            %\n          "),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex-align-center" }, [
                    _c("div", [
                      _vm._v("\n              已抓拍学生总数\n              "),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(
                          _vm._s(_vm.collectedInfo.cameraStudentFaceCount || 0)
                        ),
                      ]),
                    ]),
                    _c("div", { staticStyle: { margin: "0 5px" } }, [
                      _vm._v("/"),
                    ]),
                    _c("div", [
                      _vm._v("\n              人脸录入数\n              "),
                      _c("span", { staticClass: "num" }, [
                        _vm._v(_vm._s(_vm.collectedInfo.studentFaceCount || 0)),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "child-full-width teacher-manage-bgColor",
          staticStyle: { "margin-top": "20px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "title-1",
              staticStyle: { padding: "15px 0 5px 0" },
            },
            [_vm._v(_vm._s(_vm.remindStu.title))]
          ),
          _c("div", { staticClass: "row-box-card flex-align-center" }, [
            _c(
              "div",
              { staticClass: "pie-item-card" },
              [
                _c(
                  "div",
                  { staticClass: "flex-align-center" },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-align-center tag-list" },
                      _vm._l(_vm.timeTagList3, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: {
                              "list-tag-item": true,
                              "active-tag": _vm.remindStuTagIndex == index,
                            },
                            on: {
                              click: function ($event) {
                                _vm.remindStuTagIndex = index
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _c("a-range-picker", {
                      staticStyle: { width: "220px", margin: "0 15px" },
                      attrs: {
                        getCalendarContainer: (node) => node.parentNode,
                      },
                      model: {
                        value: _vm.remindStuDateRange,
                        callback: function ($$v) {
                          _vm.remindStuDateRange = $$v
                        },
                        expression: "remindStuDateRange",
                      },
                    }),
                    _c(
                      "a-button",
                      {
                        attrs: { icon: "search", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.remindStuQuery(true)
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "title-2",
                    staticStyle: { margin: "15px 0 10px 0" },
                  },
                  [
                    _vm._v("\n          班主任提醒名单关爱率\n          "),
                    _c("span", { staticClass: "title-num" }, [
                      _vm._v(_vm._s(_vm.teacherHandInfo.processRate) + "%"),
                    ]),
                    _vm._v("\n          ，未关爱率\n          "),
                    _c(
                      "span",
                      {
                        staticClass: "title-num",
                        staticStyle: { color: "#e16156" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.teacherHandInfo.untreatedRate) +
                            "%\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _c("div", [
                  _vm._v("\n          已处理提醒人次\n          "),
                  _c("span", { staticClass: "sub-text" }, [
                    _vm._v(_vm._s(_vm.teacherHandInfo.doneNum)),
                  ]),
                  _vm._v("\n          / 总提醒人次\n          "),
                  _c("span", { staticClass: "sub-text" }, [
                    _vm._v(_vm._s(_vm.teacherHandInfo.totalNum)),
                  ]),
                  _vm._v("\n          ， 未处理提醒人次\n          "),
                  _c("span", { staticClass: "sub-text" }, [
                    _vm._v(_vm._s(_vm.teacherHandInfo.pendingNum)),
                  ]),
                  _vm._v("\n          / 总提醒人次\n          "),
                  _c("span", { staticClass: "sub-text" }, [
                    _vm._v(_vm._s(_vm.teacherHandInfo.totalNum)),
                  ]),
                ]),
                _c("PieChartCard", {
                  staticStyle: {
                    height: "240px",
                    border: "none",
                    padding: "0",
                    "margin-top": "20px",
                  },
                  attrs: {
                    item: _vm.remindStu.list[0],
                    legendStyle: { transform: "translateY(-20px)" },
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pie-item-card" },
              [
                _vm._m(0),
                _c("ClassTeaHandSituat", {
                  ref: "classTeaHandSituatRef",
                  staticStyle: { padding: "0" },
                }),
              ],
              1
            ),
          ]),
          _c("ReminderNumCard", {
            staticStyle: { height: "340px", margin: "15px 0 20px 0" },
          }),
        ],
        1
      ),
      _c(
        "a-row",
        [
          _c(
            "a-col",
            {
              staticClass: "title-1",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { span: 24 },
            },
            [_vm._v("班主任使用概览")]
          ),
          _c(
            "a-col",
            {
              staticStyle: {
                overflow: "hidden",
                "background-color": "#fff",
                "border-radius": "10px",
              },
              attrs: { span: 24 },
            },
            [
              _c(
                "a-col",
                {
                  staticStyle: { "padding-right": "8px" },
                  attrs: { span: 12 },
                },
                [
                  _c(
                    "a-card",
                    {
                      staticClass: "left-card-box",
                      staticStyle: { border: "none" },
                      attrs: { bordered: false, loading: _vm.loading },
                    },
                    [
                      _c(
                        "LineChart",
                        {
                          ref: "teacherVisitChartRef",
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: {
                            dataSource: _vm.teacherVisitChart.dataSource,
                            fields: _vm.teacherVisitChart.fields,
                            height: "260px",
                            grid: _vm.grid,
                            title: "教师访问量趋势",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex-align-center",
                              attrs: { slot: "titleExtra" },
                              slot: "titleExtra",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-align-center tag-list" },
                                _vm._l(
                                  _vm.timeTagList2,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        class: {
                                          "list-tag-item": true,
                                          "active-tag":
                                            _vm.teaVisitTagIndex == index,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.teaVisitTagIndex = index
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _c(
                                "div",
                                [
                                  _c("a-range-picker", {
                                    staticStyle: {
                                      width: "220px",
                                      margin: "0 15px",
                                    },
                                    attrs: { "allow-clear": false },
                                    model: {
                                      value: _vm.teaVisitDateRange,
                                      callback: function ($$v) {
                                        _vm.teaVisitDateRange = $$v
                                      },
                                      expression: "teaVisitDateRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: { icon: "search", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.teaVisitQuery(true)
                                    },
                                  },
                                },
                                [_vm._v("查询")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { staticStyle: { "padding-left": "8px" }, attrs: { span: 12 } },
                [
                  _c(
                    "a-card",
                    {
                      staticClass: "right-card-box",
                      staticStyle: { padding: "0", border: "none" },
                      attrs: { bordered: false, loading: _vm.loading },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "title-right-extra flex-between" },
                        [
                          _c("div", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.teacherUseList.title) +
                                "\n            "
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex-align-center" },
                            [
                              _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    margin: "0 15px",
                                    "border-color": "#13b999",
                                    "background-color": "#13b999",
                                  },
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.exportXlsLoading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleExportXls(
                                        "教师使用情况",
                                        {
                                          beginDate: _vm.teaVisitDateRange[0],
                                          endDate: _vm.teaVisitDateRange[1],
                                        }
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                导出\n              "
                                  ),
                                ]
                              ),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.viewTeaUsageModal },
                                },
                                [_vm._v("一键提醒")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c("a-table", {
                        attrs: {
                          dataSource: _vm.teacherUseList.tableData,
                          columns: _vm.teacherUseList.columns,
                          loading: _vm.teaLoading,
                          scroll: { y: 210 },
                          bordered: "",
                          size: "small",
                          pagination: false,
                        },
                        on: { change: _vm.handleTableChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "child-full-width psy-teacher-manage-bgColor",
          staticStyle: { "margin-top": "20px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "title-1",
              staticStyle: { padding: "15px 0 5px 0" },
            },
            [_vm._v(_vm._s(_vm.mentalHealthObj.title))]
          ),
          _c(
            "div",
            {
              staticClass: "row-box flex-align-center",
              staticStyle: { "flex-wrap": "wrap", padding: "0" },
            },
            _vm._l(_vm.mentalHealthObj.list, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "pie-item" },
                [
                  index == 0
                    ? _c("PieChartCard", { attrs: { item: item } }, [
                        _c(
                          "div",
                          { staticClass: "flex-align-center" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex-align-center tag-list" },
                              _vm._l(_vm.timeTagList3, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    class: {
                                      "list-tag-item": true,
                                      "active-tag": _vm.mentalTagIndex == index,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.mentalTagIndex = index
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _c("a-range-picker", {
                              staticStyle: { width: "220px", margin: "0 15px" },
                              attrs: {
                                getCalendarContainer: (node) => node.parentNode,
                              },
                              model: {
                                value: _vm.mentalDateRange,
                                callback: function ($$v) {
                                  _vm.mentalDateRange = $$v
                                },
                                expression: "mentalDateRange",
                              },
                            }),
                            _c(
                              "a-button",
                              {
                                attrs: { icon: "search", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.mentalQuery(true)
                                  },
                                },
                              },
                              [_vm._v("查询")]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _c("MyPlan", { attrs: { planData: item } }),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "title-1", staticStyle: { "margin-top": "10px" } },
            [_vm._v(_vm._s(_vm.mainCareStu.title))]
          ),
          _c(
            "div",
            {
              staticClass: "row-box flex-align-center",
              staticStyle: { "flex-wrap": "wrap", padding: "0" },
            },
            _vm._l(_vm.mainCareStu.list, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "pie-item" },
                [
                  _c("PieChartCard", {
                    staticStyle: { height: "340px" },
                    attrs: { item: item },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _vm.isShowActivity
        ? _c(
            "a-row",
            [
              _c(
                "a-col",
                {
                  staticClass: "title-1",
                  staticStyle: { margin: "0 0 10px" },
                  attrs: { span: 24 },
                },
                [_vm._v("学生/家长活跃情况")]
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-card",
                    {
                      staticClass: "left-card-box",
                      attrs: { bordered: false, loading: _vm.loading },
                    },
                    [
                      _c("div", { staticClass: "flex-between" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-bottom": "10px",
                              "font-size": "16px",
                              "font-weight": "bold",
                              color: "#1e1e1e",
                            },
                          },
                          [
                            _vm._v(
                              "\n            学生/家长活跃度对比\n          "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "flex-align-center" },
                          [
                            _c(
                              "div",
                              { staticClass: "flex-align-center tag-list" },
                              _vm._l(_vm.timeTagList2, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    class: {
                                      "list-tag-item": true,
                                      "active-tag":
                                        _vm.activityTagIndex == index,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.activityTagIndex = index
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _c("a-range-picker", {
                              staticStyle: { width: "220px", margin: "0 15px" },
                              attrs: { "allow-clear": false },
                              model: {
                                value: _vm.vitalityDateRange,
                                callback: function ($$v) {
                                  _vm.vitalityDateRange = $$v
                                },
                                expression: "vitalityDateRange",
                              },
                            }),
                            _c(
                              "a-button",
                              {
                                attrs: { icon: "search", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.vitalityQuery(true)
                                  },
                                },
                              },
                              [_vm._v("查询")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "a-row",
                        { attrs: { gutter: [30, 0] } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("LineChart", {
                                ref: "studentActivityRef",
                                staticStyle: { "margin-bottom": "10px" },
                                attrs: {
                                  dataSource: _vm.studentActivity,
                                  fields: ["学生活跃度"],
                                  grid: _vm.grid,
                                  height: "250px",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c("LineChart", {
                                ref: "parentVisitRef",
                                staticStyle: { "margin-bottom": "10px" },
                                attrs: {
                                  dataSource: _vm.parentVisit,
                                  fields: ["家长活跃度"],
                                  grid: _vm.grid,
                                  height: "250px",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("AddEventModal", {
        ref: "addEventModal",
        on: { refresh: _vm.refreshMarked },
      }),
      _c("TeacherCareModal", { ref: "teacherCareModal" }),
      _c("TeacherUsageModal", {
        ref: "teacherUsageModalRef",
        attrs: { tableData: _vm.teacherUseList.tableData },
      }),
      _c("a-back-top", {
        attrs: { target: _vm.targetFn, visibilityHeight: 400 },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "title-2 flex-align-center",
        staticStyle: { margin: "2px 0 10px 0" },
      },
      [
        _c("span", { staticClass: "title-block" }),
        _vm._v("\n          学生提醒\n        "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }